class FilterBoxSidebarSearchComponent {
    private filterSidebar!: HTMLElement;
    private filterSidebarSearchInput!: HTMLInputElement;

    private filterOptionsNodeList!: NodeListOf<HTMLElement>;

    public onDomLoaded() {
        this.filterSidebar = document.getElementById("filter-sidebar") as HTMLElement;

        if (!this.filterSidebar)
            return;

        this.filterSidebarSearchInput = document.getElementById("filter-sidebar__search") as HTMLInputElement;

        this.filterSidebarSearchInput.addEventListener("input", (event: InputEvent) => {
            this.handleFilterSideBarSearch(event);
        });

        this.filterOptionsNodeList = this.filterSidebar.querySelectorAll(".filter-sidebar__option");
    }

    private handleFilterSideBarSearch(event: InputEvent) {
        const target = event.target as HTMLInputElement;

        if (!target)
            return;

        const value = target.value.toLowerCase();

        this.filterOptionsNodeList.forEach((optionContainer) => {
            const option = optionContainer.querySelector(".filter-sidebar__option-text") as HTMLElement;

            if (!option?.innerHTML.toLowerCase().includes(value))
                optionContainer.style.setProperty("display","none", "important");
            else
                optionContainer.style.removeProperty("display");
        })
    }
}

const filterBoxComponent = new FilterBoxSidebarSearchComponent();

export default filterBoxComponent;

document.addEventListener("DOMContentLoaded", () => filterBoxComponent.onDomLoaded(), { once: true });